module.exports = __webpack_public_path__ + "static/media/default-reward.5e2bd486.png";